import { playAvatarAudio } from '../../../common/avatar/avatarActions';
import {
    blockScreen,
    greyOutScreen,
    unblockScreen,
    greyOutOkButton,
    colorInOkButton,
} from '../../../common/screen/screenActions';
import { setIsReadyScriptPlayed } from '../../mazeActions';

export const narrateReadyScript = scrollInstructions => dispatch => {
    dispatch(blockScreen());
    dispatch(greyOutScreen());
    dispatch(greyOutOkButton());
    return dispatch(
        playAvatarAudio([
            scrollInstructions.scrollInstruction,
            scrollInstructions.scrollReadyClickOk,
        ]),
    ).then(() => {
        dispatch(setIsReadyScriptPlayed(true));
        dispatch(unblockScreen());
        dispatch(colorInOkButton());
    });
};

export default narrateReadyScript;
